"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _Box = _interopRequireDefault(require("@commerce-ui/core2/Box"));
var _QuantityPicker = require("../QuantityPicker");
var _langLibrary = _interopRequireDefault(require("@deosite/helpers/langLibrary"));
var _usePagination = _interopRequireDefault(require("@commerce-ui/core/usePagination"));
var _usePaginationLoader2 = require("@deosite/api/hooks/common/usePaginationLoader");
var __jsx = _react["default"].createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var PreviousArrowIcon = function PreviousArrowIcon(props) {
  return __jsx("svg", props, __jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.952 12.748l8.133-8.495-.866-.83-8.92 9.316 8.915 9.51.876-.821-8.138-8.68z"
  }));
};
PreviousArrowIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
};
var NextArrowIcon = function NextArrowIcon(props) {
  return __jsx("svg", props, __jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.436 12.748L7.303 4.253l.867-.83 8.92 9.316-8.916 9.51-.875-.821 8.137-8.68z"
  }));
};
NextArrowIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
};
var Pagination = function Pagination(props) {
  var pagesAmount = props.pagesAmount,
    currentPage = props.currentPage,
    onChange = props.onChange,
    prevButton = props.prevButton,
    nextButton = props.nextButton,
    qtyPicker = props.qtyPicker,
    font = props.font;
  var translations = {
    of: (0, _langLibrary["default"])("of"),
    page: (0, _langLibrary["default"])("page")
  };
  var _usePaginationLoader = (0, _usePaginationLoader2.usePaginationLoader)(),
    isLoading = _usePaginationLoader.isLoading;
  var pagination = (0, _usePagination["default"])({
    count: pagesAmount,
    current: parseInt(currentPage),
    onChange: onChange
  });
  var quantityPicker = (0, _QuantityPicker.useQuantityPicker)({
    defaultValue: currentPage,
    maxValue: pagesAmount,
    label: translations.page,
    onChange: pagination.goTo
  });
  var buttonPrevious = /*#__PURE__*/_react["default"].cloneElement(prevButton, _objectSpread(_objectSpread({}, pagination.prevButtonProps), {}, {
    disabled: isLoading,
    onChange: pagination.goToPrev,
    "data-test": "pagination-prev",
    sx: {
      fill: "active",
      fillOpacity: pagination.prevButtonActive ? "1" : "0.2",
      mr: "s6"
    }
  }), __jsx(PreviousArrowIcon, null));
  var buttonNext = /*#__PURE__*/_react["default"].cloneElement(nextButton, _objectSpread(_objectSpread({}, pagination.nextButtonProps), {}, {
    disabled: isLoading,
    onChange: pagination.goToNext,
    "data-test": "pagination-next",
    sx: {
      fill: "active",
      fillOpacity: pagination.nextButtonActive ? "1" : "0.2",
      ml: "s6"
    }
  }), __jsx(NextArrowIcon, null));
  return pagesAmount > 1 ? __jsx(_Box["default"], {
    sx: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "center",
      alignItems: "center"
    }
  }, buttonPrevious, " ", __jsx(_Box["default"], {
    as: "span",
    sx: {
      width: "120px",
      color: "main",
      font: font !== null && font !== void 0 ? font : "base_sans",
      lineHeight: "29px",
      height: "24px",
      display: "flex",
      opacity: isLoading ? ".4" : "1",
      justifyContent: "center"
    }
  }, __jsx(_Box["default"], null, /*#__PURE__*/_react["default"].cloneElement(qtyPicker, {
    controller: quantityPicker
  })), __jsx(_Box["default"], {
    sx: {
      marginLeft: "10px"
    }
  }, translations.of, " ", pagination.count)), " ", buttonNext) : null;
};
var _default = Pagination;
exports["default"] = _default;